/**
 * Loads article variants for the article content layer
 */
window.loadAjaxVariants = (selector) => {
    $(selector).ajaxVariants();
}
